/**
 * @generated SignedSource<<3a6063812fa8e219bce8b85662166fe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "totalCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "totalcount",
        "variableName": "totalCount"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "VendorTopResellerAccountsConnection",
    "kind": "LinkedField",
    "name": "getvendortopresellers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VendorTopResellerAccount",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ttlTmBcSum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ttlTmRebateSum",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorDashboardTopResellersQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorDashboardTopResellersQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5e7d4949fef32250de3474d50e84701d",
    "id": null,
    "metadata": {},
    "name": "VendorDashboardTopResellersQuery",
    "operationKind": "query",
    "text": "query VendorDashboardTopResellersQuery(\n  $vendorAccountId: UUID\n  $totalCount: Int\n) {\n  getvendortopresellers(vendoraccountid: $vendorAccountId, totalcount: $totalCount) {\n    nodes {\n      accountId\n      accountName\n      contactLastName\n      contactFirstName\n      subscriptionCount\n      ttlTmBcSum\n      ttlTmRebateSum\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7e8067ae33cf5499df5ee730f6707337";

module.exports = node;
